import React, { useState, useEffect } from "react";
import { useLanguage } from "../context/LanguageContext";
import { useContent } from "../context/ContentContext";
import { IMAGES, STATS } from "../mock";
import { api } from "../lib/api";

const About = () => {
  const { t, lang } = useLanguage();
  const { cval } = useContent();
  const [team, setTeam] = useState([]);

  useEffect(() => {
    api.listTeam().then(setTeam).catch(() => {});
  }, []);

  const role = (tm) => (lang === "en" && tm.role_en ? tm.role_en : tm.role_pt);

  return (
    <div>
      {/* Hero */}
      <section className="relative pt-40 pb-24 px-6 overflow-hidden">
        <div className="absolute inset-0">
          <img src={IMAGES.detail1} alt="About hero" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#070b18]/85 via-[#070b18]/85 to-[#070b18]" />
        </div>
        <div className="relative z-10 text-center max-w-3xl mx-auto bf-section-fade">
          <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-4">{t("about_title")}</h1>
          <p className="text-lg md:text-xl bf-cyan-text font-medium">{t("about_subtitle")}</p>
        </div>
      </section>

      {/* Founder */}
      <section className="py-20 px-6 bg-[#0a1024]">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center">
          <div className="relative rounded-2xl overflow-hidden border border-white/10 bf-card-hover">
            <img src={IMAGES.heroBg} alt="Rui Silva" className="w-full h-[440px] object-cover" />
          </div>
          <div>
            <h2 className="text-3xl font-extrabold text-white mb-6">{cval("about_founder", lang, t("about_founder"))}</h2>
            <p className="text-gray-400 leading-relaxed mb-4">{cval("about_p1", lang, t("about_p1"))}</p>
            <p className="text-gray-400 leading-relaxed mb-6">{cval("about_p2", lang, t("about_p2"))}</p>
            <p className="text-white font-semibold leading-relaxed border-l-2 border-[#22d3ee] pl-4">{t("about_mission")}</p>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-20 px-6">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
          {STATS.map((s, i) => (
            <div key={s.key} className="relative rounded-2xl overflow-hidden border border-white/10 group h-56">
              <img src={[IMAGES.workshop, IMAGES.detail3, IMAGES.detail1][i]} alt={t(s.key)} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
              <div className="absolute inset-0 bg-[#070b18]/70 flex flex-col items-center justify-center">
                <div className="text-4xl md:text-5xl font-extrabold bf-cyan-text">{s.value}</div>
                <div className="text-gray-200 mt-2 font-medium">{t(s.key)}</div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Factory teams */}
      <section className="py-20 px-6 bg-[#0a1024]">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-extrabold text-white text-center mb-14">{t("about_teams_title")}</h2>
          <div className="grid md:grid-cols-3 gap-6">
            {team.map((tm) => (
              <div key={tm.id} className="bf-glass bf-card-hover rounded-2xl overflow-hidden">
                <img src={tm.image} alt={tm.team} className="w-full h-52 object-cover" />
                <div className="p-6">
                  <h3 className="text-lg font-bold text-white mb-1">{tm.team}</h3>
                  <p className="text-[#67e8f9] text-sm">{role(tm)}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
